'use client';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { useLocalStorage } from 'usehooks-ts';

import env from '@/consts/env';
import { OAUTH_POPUP_CALLBACK_PATH } from '@/consts/google-oauth';
import { protectedRoutes } from '@/consts/route';
import { usePartnerConfig } from '@/providers/TenantProvider';

const SandboxRedirect = () => {
  const router = useRouter();
  const pathname = usePathname();
  const [isVerified] = useLocalStorage('cm_s_verified', false);
  const config = usePartnerConfig();

  // 매직링크 기반 파트너는 SandboxRedirect 불필요
  const skipRedirect = config.auth.strategy === 'session-storage';

  useEffect(() => {
    if (skipRedirect) return;

    // 구글 OAuth 팝업 relay는 결과 전달만 하고 닫히는 창이라 sandbox 게이트에서 제외
    if (pathname.includes(OAUTH_POPUP_CALLBACK_PATH.replace(/\/$/, ''))) return;

    if (!isVerified) {
      if (env === 'development' || env === 'local') {
        if (!pathname.includes(protectedRoutes.root)) {
          router.replace(protectedRoutes.root);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, isVerified, skipRedirect]);

  return <></>;
};

export default SandboxRedirect;
